import { api } from './auth.service';

const planejamentoCapacidadeService = {
  // Resumo: pra cada analista, previstas/alocadas/pendentes/data_inicio/prazo_final
  resumo: async (negocioId) => {
    const r = await api.get(`/planejamento-capacidade/${negocioId}/resumo`);
    return r.data;
  },

  // Lista todas as datas de início definidas no projeto
  listarDatasInicio: async (negocioId) => {
    const r = await api.get(`/planejamento-capacidade/${negocioId}/datas-inicio`);
    return r.data;
  },

  // Define ou atualiza data de início pra um analista
  upsertDataInicio: async (negocioId, colabId, dados) => {
    const r = await api.put(
      `/planejamento-capacidade/${negocioId}/analista/${colabId}/data-inicio`,
      dados
    );
    return r.data;
  },

  // Remove data de início de um analista
  removerDataInicio: async (negocioId, colabId) => {
    const r = await api.delete(
      `/planejamento-capacidade/${negocioId}/analista/${colabId}/data-inicio`
    );
    return r.data;
  },
};

export default planejamentoCapacidadeService;
